import { render, staticRenderFns } from "./AccountVerificationEmailSentRouterView.vue?vue&type=template&id=331bf3aa&"
import script from "./AccountVerificationEmailSentRouterView.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationEmailSentRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports